import PropTypes from 'prop-types';
import ResponsiveImage from "components/ui/ResponsiveImage/ResponsiveImage";

const ParagraphMedia = ({ title, media }) => {
  return (
    <>
      { title && <h2>{ title }</h2> }
      <ResponsiveImage value={ media }/>
    </>
  )
}

ParagraphMedia.propTypes = {
  title: PropTypes.string,
  media: PropTypes.string.isRequired,
}

export default ParagraphMedia;
